const t = {
  name: "SearchSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C12.5723 18 14.0235 17.4816 15.1921 16.6064L18.9999 20.4142L20.4141 19L16.6063 15.1922C17.4816 14.0236 18 12.5724 18 11C18 7.13401 14.866 4 11 4ZM6 11C6 8.23858 8.23858 6 11 6C13.7614 6 16 8.23858 16 11C16 13.7614 13.7614 16 11 16C8.23858 16 6 13.7614 6 11Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as SearchSmall
};
